import type { Member } from '#utils/members/records/Member';
import type { Team } from '#utils/teams/records/Team';

export function validateNotifyReviewersCount(maxLength: number, teams: Team[], members: Member[]) {
  let count = members.length;
  for (const team of teams) {
    if (team.members) {
      count += team.members?.totalCount;
    }
  }
  return count > maxLength;
}
